/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaymentMethodDetails } from './PaymentMethodDetails';
export type SubscriptionDetailsResponse = {
    plan: SubscriptionDetailsResponse.plan;
    status: string;
    priceMonthly: string | null;
    currentPeriodEnd: string;
    cancelAtPeriodEnd: boolean;
    trialEnd: string | null;
    paymentMethod: PaymentMethodDetails | null;
};
export namespace SubscriptionDetailsResponse {
    export enum plan {
        FREE = 'free',
        PAID = 'paid',
        MULTI_USER = 'multiUser',
    }
}

